import { getRegionCodesSortedByKeyRegions } from '@luxuryescapes/lib-regions';

// RU (Russia) is not an operating market for Luxury Escapes and must never be
// selectable when managing search ordering scores, regardless of the
// EXCLUDED_REGIONS environment config.
const ALWAYS_EXCLUDED_REGIONS = ['RU'];

// Returns the region codes available in the search ordering screens, sorted with
// key regions first and with both the environment-configured EXCLUDED_REGIONS and
// the always-excluded regions removed. Mirrors the region handling used by the
// offer list ordering screen (OfferListOrderContainer).
export const getSearchOrderingRegionCodes = (): Array<string> => {
  const configuredExclusions = window.configs.EXCLUDED_REGIONS ? window.configs.EXCLUDED_REGIONS.split(',') : [];

  const { allRegionCodes } = getRegionCodesSortedByKeyRegions(undefined, [
    ...configuredExclusions,
    ...ALWAYS_EXCLUDED_REGIONS,
  ]);

  return allRegionCodes;
};
